import { FooterComponent } from './modules/layout/footer/footer.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LandingComponent } from './components/landing/landing.component';
import { InterceptService } from './modules/core/intercept.service';
import { LayoutModule } from './modules/layout/layout.module';
import { AwssurveyComponent } from './components/awssurvey/awssurvey.component';
import { FlexLayoutModule } from '@angular/flex-layout';

import { MatSidenavModule } from '@angular/material/sidenav';
import { RedirectComponent } from './components/redirect/redirect.component';
import { SharedModule } from './shared/shared.module';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { CacheInterceptor } from './modules/core/cache.interceptor';
import { NewsItemComponent } from './components/news-item/news-item.component';
import { OverviewComponent } from './components/overview/overview.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';

import { environment } from '../environments/environment';
import { MatIconModule } from '@angular/material/icon';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CacheMapService } from './modules/core/cache-map.service';
import { Cache } from './modules/core/cache';
import { SplashScreenComponent } from './components/splash-screen/splash-screen.component';
import { AngularTwitterTimelineModule } from 'angular-twitter-timeline';
import { AuthService } from './auth.service';
import { MappingComponent } from './components/mapping/mapping.component';
import { LargeTexasCityComponent } from './components/case-studies/large-texas-city/large-texas-city.component';
import { HealthCareLandingZoneComponent } from './components/case-studies/health-care-landing-zone/health-care-landing-zone.component';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MigrationLargeTexasCityComponent } from './components/case-studies/migration-large-texas-city/migration-large-texas-city.component';
import { MigrationLargeTexasHospitalComponent } from './components/case-studies/migration-large-texas-hospital/migration-large-texas-hospital.component';
import { MigrationLargeTexasCityDraasComponent } from './components/case-studies/migration-large-texas-city-draas/migration-large-texas-city-draas.component';
import { MigrationMultiNationalFinancialOrganizationComponent } from './components/case-studies/migration-multi-national-financial-organization/migration-multi-national-financial-organization.component';
import { DigitalWorkspaceOrangeUnifiedSchoolDistrictComponent } from './components/case-studies/digital-workspace-orange-unified-school-district/digital-workspace-orange-unified-school-district.component';
import { DigitalWorkspaceSundownISDAndNetsyncComponent } from './components/case-studies/digital-workspace-sundown-isd-and-netsync/digital-workspace-sundown-isd-and-netsync.component';
import { CloudReadinessAssessmentComponent } from './components/assessment/cloud-readiness-assessment/cloud-readiness-assessment.component';
import { CloudReadinessReportComponent } from './components/assessment/cloud-readiness-report/cloud-readiness-report.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { NgxEchartsModule } from 'ngx-echarts';

@NgModule({ declarations: [
        AppComponent,
        LandingComponent,
        RedirectComponent,
        AwssurveyComponent,
        UnauthorizedComponent,
        FooterComponent,
        NewsItemComponent,
        OverviewComponent,
        SplashScreenComponent,
        MappingComponent,
        LargeTexasCityComponent,
        HealthCareLandingZoneComponent,
        MigrationLargeTexasCityComponent,
        MigrationLargeTexasHospitalComponent,
        MigrationLargeTexasCityDraasComponent,
        MigrationMultiNationalFinancialOrganizationComponent,
        DigitalWorkspaceOrangeUnifiedSchoolDistrictComponent,
        DigitalWorkspaceSundownISDAndNetsyncComponent,
        CloudReadinessAssessmentComponent,
        CloudReadinessReportComponent,
    ],
    bootstrap: [AppComponent], imports: [CarouselModule,
        BrowserModule,
        AppRoutingModule,
        FlexLayoutModule,
        OAuthModule.forRoot(),
        LayoutModule,
        BrowserAnimationsModule,
        MatCardModule,
        MatSidenavModule,
        LoadingBarRouterModule,
        MatIconModule,
        MatTooltipModule,
        SharedModule.forRoot(),
        AngularTwitterTimelineModule,
        MatButtonModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            registrationStrategy: 'registerImmediately',
        }),
        ReactiveFormsModule,
        MatToolbarModule,
        MatTabsModule,
        MatProgressBarModule,
        MatRadioModule,
        NgxEchartsModule.forRoot({
            echarts: () => import('echarts')
        })], providers: [
        InterceptService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CacheInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptService,
            multi: true,
        },
        CacheMapService,
        {
            provide: Cache,
            useClass: CacheMapService,
        },
        AuthService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
